/**
 * Drill utility functions
 * Shared helpers for drill-related operations across the app
 */

/**
 * FT-91/FT-213: Normalize drill outcome for case-insensitive comparison
 * Handles various stored formats: "Successful", "successful", "passed", etc.
 *
 * @param {string} outcome - The raw outcome value from storage
 * @returns {'successful' | 'failed'} - Normalized lowercase outcome
 */
export const normalizeOutcome = (outcome) => {
  if (!outcome) return 'failed';
  const normalized = outcome.toLowerCase();
  // Accept various success indicators
  if (normalized === 'successful' || normalized === 'success' || normalized === 'passed' || normalized === 'pass') {
    return 'successful';
  }
  return 'failed';
};
